import { styled } from "@mui/material"
import { extraColors } from "../utils/theme"

const StyledTag = styled("span")({
  padding: "1px 6px",
  borderRadius: "2px",
  border: `1px solid ${extraColors.status.navyMuted}`,
  background: extraColors.status.navyDeep,
  color: extraColors.status.navyLight,
  fontSize: 10,
  fontWeight: 600,
})

export const BetaTag = () => <StyledTag>Beta</StyledTag>
